import { render, staticRenderFns } from "./PartnerLayout.vue?vue&type=template&id=412e82f4&scoped=true&"
import script from "./PartnerLayout.vue?vue&type=script&lang=ts&"
export * from "./PartnerLayout.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerLayout.vue?vue&type=style&index=0&id=412e82f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412e82f4",
  null
  
)

export default component.exports